import React from 'react';
import { X } from 'lucide-react';
import { DataTable } from '../../../components/common';
import { useLocalization } from '../../../contexts/LocalizationContext';
import styles from './StaffSlabBreakdownModal.module.css';

const StaffSlabBreakdownModal = ({ staffRow, onClose }) => {
  const { t, formatCurrency } = useLocalization();

  const slabColumns = [
    { key: 'minValue', header: t('callCenterShifts.minValue'), render: (row) => row.minValue },
    {
      key: 'maxValue',
      header: t('callCenterShifts.maxValue'),
      render: (row) => (row.maxValue != null ? row.maxValue : t('callCenterShifts.openEnded')),
    },
    { key: 'rate', header: t('callCenterShifts.amountPerUnit'), render: (row) => `${row.rate}%` },
    { key: 'slabQty', header: t('callCenterShifts.slabQty'), render: (row) => row.slabQty },
    { key: 'slabTotal', header: t('callCenterShifts.slabTotal'), render: (row) => formatCurrency(row.slabTotal) },
  ];

  return (
    <div className={styles.modalOverlay} onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2>{staffRow.user?.name || t('callCenterCommission.staffMember')} — {t('callCenterShifts.commissionCalculation')}</h2>
          <button onClick={onClose} className={styles.closeButton}>
            <X size={20} />
          </button>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.summaryRow}>
            <div className={styles.summaryItem}>
              <span className={styles.summaryLabel}>{t('callCenterShifts.achievedSalesValue')}</span>
              <span className={styles.summaryValue}>{formatCurrency(staffRow.achievedSalesValue)}</span>
            </div>
            <div className={styles.summaryItem}>
              <span className={styles.summaryLabel}>{t('callCenterCommission.commissionAmount')}</span>
              <span className={styles.summaryValue}>{formatCurrency(staffRow.commissionValue)}</span>
            </div>
          </div>

          <DataTable
            data={staffRow.slabBreakdown || []}
            columns={slabColumns}
            emptyMessage={t('callCenterShifts.noSlabsConfigured')}
          />
        </div>

        <div className={styles.modalFooter}>
          <button type="button" onClick={onClose} className={styles.closeFooterButton}>
            {t('common.close')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StaffSlabBreakdownModal;
